<template>
    <div v-if="loaded">
        <work-order-client :work-order="upsertWorkOrder" />
        <work-order-info :work-order-upsert="upsertWorkOrder" />

        <work-order-time-registration
            :work-order-time-registrations="upsertWorkOrder.data.work_time_registration"
        ></work-order-time-registration>

        <div class="viewport">
            <md-toolbar :md-elevation="1">
                <span class="md-title">Materiaal</span>
            </md-toolbar>

            <md-list class="md-triple-line">
                <md-list-item v-for="(workOrderLineItem, index) in upsertWorkOrder.work_order_lines" :key="index">
                    <md-avatar>
                        <img src="../../assets/product.jpg" alt="product" />
                    </md-avatar>
                    <div class="md-list-item-text">
                        <span>{{ workOrderLineItem.product.name }}</span>
                        <span>{{ 'Product number: ' + workOrderLineItem.product.product_number }}</span>
                        <p>{{ workOrderLineItem.product.specifications.description }}</p>
                        <p>
                            {{
                                workOrderLineItem.quantity +
                                ' (' +
                                workOrderLineItem.product.pricing?.unit_amount +
                                ' ' +
                                workOrderLineItem.product.pricing?.unit_type +
                                ')'
                            }}
                        </p>
                        <p v-if="pricingEnabled && lineHasPricing(workOrderLineItem)">
                            {{ workOrderLineItem.unit_price }} € × {{ workOrderLineItem.quantity }} — Totaal
                            {{ lineTotal(workOrderLineItem) }} €
                        </p>
                    </div>
                    <md-button class="md-icon-button md-list-action" @click="deleteWorkOrderLine(index)">
                        <md-icon>delete</md-icon>
                    </md-button>
                </md-list-item>
                <md-divider v-if="upsertWorkOrder.work_order_lines.length > 0"></md-divider>
                <md-list-item v-if="pricingEnabled && hasPricedLines">
                    <md-field style="max-width: 120px">
                        <label>BTW</label>
                        <md-select id="vat_percentage" name="vat_percentage" v-model="vatPercentage">
                            <md-option :key="percentage" :value="percentage" v-for="percentage in vatPercentages"
                                >{{ Math.round(percentage * 100) }}%</md-option
                            >
                        </md-select>
                    </md-field>
                    <div class="md-list-item-text" style="text-align: right">
                        <span>Subtotaal: {{ totals.subTotal }} €</span>
                        <span>BTW ({{ Math.round(vatPercentage * 100) }}%): {{ totals.vatAmount }} €</span>
                        <span style="font-weight: bold">Totaal incl. BTW: {{ totals.totalInclVat }} €</span>
                    </div>
                </md-list-item>
                <md-button class="md-primary" @click="showDialogUpsertProduct = !showDialogUpsertProduct">
                    <md-icon>add</md-icon>
                    materiaal
                </md-button>
            </md-list>

            <md-toolbar :md-elevation="1">
                <span class="md-title md-list-item-text primary">Opmerkingen</span>
                <md-button
                    @click="showDialogRemarks = !showDialogRemarks"
                    class="md-icon-button md-list-action"
                    v-if="remarks"
                >
                    <md-icon>edit</md-icon>
                </md-button>
            </md-toolbar>
            <md-list class="md-double-line">
                <md-button @click="showDialogRemarks = !showDialogRemarks" class="md-primary" v-if="!remarks">
                    <md-icon>add</md-icon>
                    opmerking
                </md-button>
                <md-list-item v-if="remarks">
                    <span>{{ remarks ? remarks : '' }}</span>
                </md-list-item>
            </md-list>

            <div v-if="showPaymentMethod">
                <md-toolbar :md-elevation="1">
                    <span class="md-title">Betaal methode</span>
                </md-toolbar>
                <md-field style="padding-left: 15px">
                    <md-select id="wo_payment_method" name="wo_payment_method" v-model="paymentMethod">
                        <md-option :key="index" :value="option" v-for="(option, index) in paymentMethodTypes">
                            {{ parsePaymentMethodTypeReadable(option) }}
                        </md-option>
                    </md-select>
                </md-field>
            </div>
        </div>

        <md-button
            v-if="!isReadOnly"
            @click="upsertWorkOrderFunction()"
            style="margin-left: 0; width: 100%"
            class="md-raised md-primary"
            >Save
        </md-button>
        <div v-else class="readonly-note">
            Werkbon is {{ upsertWorkOrder.status }} en kan niet meer aangepast worden
        </div>

        <md-dialog :md-active.sync="showDialogRemarks">
            <md-dialog-title>Opmerkingen</md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <label>Opmerkingen</label>
                    <md-textarea v-model="remarks"></md-textarea>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelRemarks()" class="md-primary">Cancel</md-button>
                <md-button @click="addRemarks()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog style="z-index: 9" :md-active.sync="showDialogUpsertProduct" v-if="this.upsertWorkOrderLine">
            <md-dialog-title>Add product</md-dialog-title>

            <md-dialog-content>
                <product-search-modal
                    @set-selected-product="setSelectedProduct($event)"
                    style="padding-left: 15px; z-index: 1000"
                >
                </product-search-modal>
                <md-field>
                    <label>Beschrijving</label>
                    <md-textarea v-model="descriptionProduct"></md-textarea>
                </md-field>
                <md-field>
                    <label
                        >Aantal
                        {{
                            upsertWorkOrderLine.product
                                ? '(' +
                                  upsertWorkOrderLine.product.pricing.unit_amount +
                                  ' ' +
                                  upsertWorkOrderLine.product.pricing.unit_type +
                                  ')'
                                : ''
                        }}
                    </label>
                    <md-input
                        type="number"
                        name="quantity"
                        id="quantity"
                        v-model="upsertWorkOrderLine.quantity"
                    ></md-input>
                </md-field>
                <md-field v-if="pricingEnabled">
                    <label>Stukprijs (€)</label>
                    <md-input
                        type="number"
                        name="unit_price"
                        id="unit_price"
                        v-model="upsertWorkOrderLine.unit_price"
                    ></md-input>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelUpsertWorkOrderLine()" class="md-primary">Cancel</md-button>
                <md-button @click="upsertAddWorkOrderLine()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import router from '@/router';
import ProductSearchModal from '@/components/product-search-modal/ProductSearchModal.vue';
import * as toastr from 'toastr';
import { appStore } from '@/store';
import WorkOrderClient from '@/views/work-order/components/WorkOrderClient.vue';
import WorkOrderInfo from '@/views/work-order/components/WorkOrderInfo.vue';
import WorkOrderTimeRegistration from '@/views/work-order/components/WorkOrderTimeRegistration.vue';
import { IConfiguration, IWorkOrderEntity, PlanningState, WorkOrderStatus } from '@phrospr/lib-models';
import { workOrderStore } from '@/store/work-order/workOrder.store';
import { IProductEntity, IWorkOrderLineEntity, PaymentMethodType, WorkOrderApi } from '@phrospr/api-backend';
import { getEnumKeys } from '@phrospr/lib-core/src/engine/enum.engine';
import { parsePaymentMethodTypeReadable } from '@phrospr/lib-core/src/engine/planning-item.engine';
import {
    calculateWorkOrderLinePrice,
    calculateWorkOrderTotals,
    lineHasPricing,
    WORK_ORDER_VAT_PERCENTAGES,
} from '@phrospr/lib-core/src/engine/work-order-price.engine';

@Component({
    components: {
        WorkOrderTimeRegistration,
        WorkOrderInfo,
        WorkOrderClient,
        ProductSearchModal,
    },
})
export default class WorkOrder extends Vue {
    loaded = false;
    showDialogRemarks: boolean = false;
    remarks: string = null;

    upsertWorkOrder: IWorkOrderEntity;

    showDialogUpsertProduct = false;
    selectedProduct: IProductEntity;
    upsertWorkOrderLine: IWorkOrderLineEntity = {
        product_id: null,
        product: null,
        quantity: 0,
        creation_date: null,
        unit_price: null,
        data: {},
    };
    descriptionProduct: string = '';

    // Saving will auto-finish the linked (planned) planning item, so the payment
    // method is captured here, like in the plain finish screen.
    finishesPlanningItem = false;
    paymentMethod: PaymentMethodType = PaymentMethodType.CASH;
    paymentMethodTypes = getEnumKeys(PaymentMethodType);
    vatPercentages = WORK_ORDER_VAT_PERCENTAGES;
    // One VAT rate for the whole work order (data.vat_percentage), like quotes.
    vatPercentage = 0.21;

    @Prop() workOrderId?: number;

    constructor() {
        super();
        this.loaded = false;
        this.load();
    }

    get configuration(): Partial<IConfiguration> {
        return this.$store.state.configuration;
    }

    get pricingEnabled(): boolean {
        return !!this.configuration?.workOrders?.pricingEnabled;
    }

    get showPaymentMethod(): boolean {
        return this.finishesPlanningItem && !!this.configuration?.planning?.paymentMethod;
    }

    get hasPricedLines(): boolean {
        return (this.upsertWorkOrder?.work_order_lines ?? []).some(lineHasPricing);
    }

    get totals() {
        return calculateWorkOrderTotals(this.upsertWorkOrder?.work_order_lines ?? [], this.vatPercentage);
    }

    public lineHasPricing(line: IWorkOrderLineEntity): boolean {
        return lineHasPricing(line);
    }

    public lineTotal(line: IWorkOrderLineEntity): number {
        return calculateWorkOrderLinePrice(line);
    }

    public parsePaymentMethodTypeReadable(paymentMethod: PaymentMethodType) {
        return parsePaymentMethodTypeReadable(paymentMethod);
    }

    private async load() {
        await workOrderStore.dispatch('startWorkOrderUpsert', this.workOrderId);
        this.upsertWorkOrder = workOrderStore.state.upsertWorkOrder;
        if (this.workOrderId !== undefined) {
            if (this.upsertWorkOrder.data) {
                this.remarks = this.upsertWorkOrder.data.remarks;
                this.vatPercentage = this.upsertWorkOrder.data.vat_percentage ?? 0.21;
            }
        } else {
            if (appStore.state.workOrderCreateSettings) {
                const { client, planningItem } = appStore.state.workOrderCreateSettings;
                this.upsertWorkOrder.client_id = client.client_id;
                this.upsertWorkOrder.planning_item_id = planningItem.planning_item_id;
                this.finishesPlanningItem = planningItem.state === PlanningState.planned;
                workOrderStore.commit('setSelectedClient', client);
            } else workOrderStore.commit('setSelectedClient', null);
        }
        this.loaded = true;
    }

    // Mirrors the backend guard: only work orders in created state may be updated.
    get isReadOnly(): boolean {
        return (
            this.workOrderId !== undefined &&
            !!this.upsertWorkOrder?.status &&
            this.upsertWorkOrder.status !== WorkOrderStatus.created
        );
    }

    public async upsertWorkOrderFunction() {
        if (this.isReadOnly) {
            toastr.error(`Werkbon is ${this.upsertWorkOrder.status} en kan niet meer aangepast worden`);
            return;
        }
        if (this.upsertWorkOrder.work_order_lines.length <= 0) {
            toastr.error('Geen materiaal lijnen geselecteerd');
            return;
        }
        if (!this.upsertWorkOrder.client_id) {
            toastr.error('Geen klant geselecteerd');
            return;
        }
        if (!this.upsertWorkOrder.data.work_order_technician_user_id) {
            toastr.error('Geen technieker geselecteerd');
            return;
        }
        if (!this.upsertWorkOrder.work_order_type_id) {
            toastr.error('Geen werkbon type geselecteerd');
            return;
        }

        if (!this.upsertWorkOrder.status) this.upsertWorkOrder.status = WorkOrderStatus.created;
        if (this.pricingEnabled) {
            this.upsertWorkOrder.data.vat_percentage = this.vatPercentage;
        }
        if (this.showPaymentMethod && this.paymentMethod) {
            this.upsertWorkOrder.data.planning_item_finish = { payment_method: this.paymentMethod };
        }

        try {
            await WorkOrderApi.upsertWorkOrder(this.upsertWorkOrder);
            await router.push({ path: `/workOrder/overview` });
        } catch (e) {
            // A refusal (e.g. the type was deactivated meanwhile) carries the reason in the body;
            // drop the cached types so the next open shows the current list.
            if (e?.response?.status === 400) {
                workOrderStore.commit('invalidateWorkOrderTypes');
                toastr.error(typeof e.response.data === 'string' ? e.response.data : e.message);
            } else {
                toastr.error(e.message);
            }
        }
    }

    public async cancelRemarks() {
        this.showDialogRemarks = false;
    }

    public async addRemarks() {
        this.showDialogRemarks = false;
        this.upsertWorkOrder.data.remarks = this.remarks;
    }

    public async upsertAddWorkOrderLine() {
        if (!this.upsertWorkOrderLine.product) {
            toastr.error('Geen product geselecteerd');
            return;
        }
        if (this.pricingEnabled) {
            // md-input v-model yields strings; the server recomputes the total anyway.
            const unitPrice = parseFloat(this.upsertWorkOrderLine.unit_price as any);
            this.upsertWorkOrderLine.unit_price = Number.isFinite(unitPrice) ? unitPrice : null;
            this.upsertWorkOrderLine.quantity = parseFloat(this.upsertWorkOrderLine.quantity as any) || 0;
        } else {
            this.upsertWorkOrderLine.unit_price = null;
        }
        this.showDialogUpsertProduct = false;
        this.upsertWorkOrder.work_order_lines.push(this.upsertWorkOrderLine);
        this.resetUpsertWorkOrderLine();
    }

    public async cancelUpsertWorkOrderLine() {
        this.showDialogUpsertProduct = false;
        this.resetUpsertWorkOrderLine();
    }

    async deleteWorkOrderLine(index: number) {
        this.upsertWorkOrder.work_order_lines.splice(index, 1);
        await this.resetUpsertWorkOrderLine();
    }

    public resetUpsertWorkOrderLine() {
        this.upsertWorkOrderLine = {
            product_id: null,
            quantity: 0,
            product: null,
            data: {},
            creation_date: null,
            unit_price: null,
        };
        this.descriptionProduct = '';
    }

    public async setSelectedProduct(product: IProductEntity) {
        this.selectedProduct = product;
        this.upsertWorkOrderLine = {
            ...this.upsertWorkOrderLine,
            product: product,
            quantity: 1,
            product_id: product.product_id,
            unit_price: this.pricingEnabled ? product.pricing?.price_per_unit ?? null : null,
        };
        this.descriptionProduct = product.specifications.description;
    }
}
</script>

<style lang="scss" scoped>
.viewport {
    max-width: 100%;
    vertical-align: top;
    overflow: auto;
    border: 1px solid rgba(#000, 0.12);
    display: inherit;
    width: -webkit-fill-available;
}

.readonly-note {
    text-align: center;
    padding: 12px;
    color: #757575;
    font-style: italic;
}
</style>
